<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab active>
        <template #title>
          <feather-icon icon="UserIcon" />
          <span>Görüşe Bilgileri</span>
        </template>
        <validation-observer ref="simpleRules">
          <interview-info />
          <interview-lines :get-data="getInterview" />
          <interview-form
            v-if="userData.id === dataInterview.id_users"
            :is-first="false"
            :interview-status="dataInterview.status"
            :submit-form="submitForm"
            :submit-status="submitStatus"
          />
        </validation-observer>
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon icon="UserIcon" />
          <span>Müşteri Bilgileri</span>
        </template>
        <customer-info />
        <customer-invoice />
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon icon="ClockIcon" />
          <span>Müşteri Geçmişi</span>
        </template>
        <customer-history :customer-id="dataInterview.id_customers" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import {
  BTabs, BTab,
} from 'bootstrap-vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import InterviewForm from '@/views/Admin/Interviews/InterviewForm.vue'
import InterviewInfo from '@/views/Admin/Interviews/InterviewInfo.vue'
import InterviewLines from '@/views/Admin/Interviews/InterviewLines.vue'
import CustomerInfo from '@/views/Admin/Customers/View/CustomerInfo.vue'
import CustomerInvoice from '@/views/Admin/Customers/View/CustomerInvoice.vue'
import CustomerHistory from '@/views/Admin/Customers/View/CustomerHistory.vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'View',
  components: {
    BTabs,
    BTab,
    InterviewForm,
    InterviewInfo,
    InterviewLines,
    CustomerInfo,
    CustomerInvoice,
    CustomerHistory,
    ValidationObserver,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      required,
      submitStatus: false,
      interview_status: null,
      id_customers: null,
      id_interviews: null,
    }
  },
  computed: {
    dataInterview() {
      return this.$store.getters['interviews/dataInterview']
    },
    dataItem() {
      return this.$store.getters['interviews/dataItem']
    },
    saveData() {
      return this.$store.getters['interviews/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.$store.commit('interviews/RESET_DATA_ITEM')
    this.getInterview()
    localize('tr')
  },
  methods: {
    getInterview() {
      this.$store.dispatch('interviews/getDataInterview', this.$route.params.id)
        .then(response => {
          if (response.id_customers) {
            this.getCustomer(response.id_customers)
            this.dataItem.id_interview_subjects = response.id_interview_subjects
            if (this.userData.id_user_types === this.$store.state.app.ProjectMarketingUserTypeId) {
              if (this.userData.id !== response.id_users) {
                this.$swal({
                  icon: 'error',
                  title: 'İşlem Başarısız',
                  text: 'Sadece kendi görüşme notlarınızı görüntüleyebilirsiniz.',
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.$router.push({ name: 'Interviews' })
              }
            }
          }
        })
    },
    getCustomer(id) {
      this.$store.dispatch('customers/getDataItem', id)
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.dataItem.id_interviews = this.$route.params.id
          this.interview_status = this.dataItem.id_interview_statuses
          this.id_customers = this.dataInterview.id_customers
          this.id_interviews = this.dataInterview.id
          this.$store.dispatch('interviews/insertLine', this.dataItem)
            .then(status => {
              if (status) {
                this.$refs.simpleRules.reset()
                this.submitStatus = false
                if (this.interview_status === '2') {
                  this.$router.push(`/app/projects/add/${this.id_customers}/${this.id_interviews}`)
                } else if (this.interview_status === '3') {
                  this.$router.push(`/app/offers/add-project/${this.id_customers}`)
                }
                this.getInterview()
              }
            })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
